import PropTypes from "prop-types";

// Components
import DoubleInput from "@Layouts/components/InputComponents/DoubleInput";
import InputFormExtension from "@Layouts/components/InputComponents/InputFormExtension";
import TierRowsItem from "@Layouts/components/Tiers/TierRowsItem";

// MUI
import { Stack } from "@mui/material";

export default function MatrixRow(props) {
	const {
		index = 0,
		item = null,
		fromDisabled = false,
		toDisabled = false,
		spaces = {
			mainSection: 100,
			columns: 100,
			totalColumns: 1,
			totalRows: 1,
			separation: 5.5,
		},
		rowsErrors = [],
		columnsErrors = [],
		readOnly = false,
		spacing = 0.8,
		mainContentProps = null,
		sxMainContent = {
			minWidth: "190px",
		},
		cellsProps = {
			justifyContent: "center",
			alignItems: "center",
		},
		sxCells = {
			minWidth: "100px",
		},
		onActionUpdate = () => {},
		onChangeType = () => {},
	} = props;

	return (
		<TierRowsItem hasShadow={!(index % 2)} spaces={spaces}>
			<Stack direction={"row"} spacing={spacing}>
				<Stack {...mainContentProps} sx={sxMainContent}>
					<DoubleInput
						firstInput={{
							data: [
								{
									type: "Percent",
									min: 0,
									max: 100,
									decimalsEditable: true,
									decimals: 2,
									delta: 0.01,
									dashed: fromDisabled,
								},
							],
							sx: { width: "70px" },
							defaultType: item?.from?.input || "Percent",
							value: item?.from?.value || 0,
							error: Boolean(rowsErrors?.[index]?.from),
							disabled: fromDisabled,
							readOnly: true,
						}}
						secondInput={{
							readOnly,
							data: [
								{
									type: "Percent",
									min: 0,
									max: 100,
									decimalsEditable: true,
									decimals: 2,
									delta: 0.01,
									dashed: toDisabled,
								},
							],
							sx: { width: "70px" },
							defaultType: item?.to?.type || "Percent",
							value: item?.to?.value || 0,
							error: Boolean(rowsErrors?.[index]?.to),
							disabled: toDisabled,
							onActionUpdate: (value) => {
								onActionUpdate?.(index, 0, "row", "to", value);
							},
						}}
					/>
				</Stack>
				<Stack direction={"row"} spacing={spacing}>
					{item?.commissions?.map((element, key) => {
						return (
							<Stack key={`call-activity-row-${index}-${key}`} {...cellsProps} sx={sxCells}>
								<InputFormExtension
									data={[
										{
											type: "Percent",
											min: -100,
											max: 100,
											decimalsEditable: true,
											decimals: 2,
											delta: 0.01,
										},
										{
											type: "Dollar",
											decimalsEditable: true,
											decimals: 2,
											delta: 0.01,
											min: Number.NEGATIVE_INFINITY,
											max: Number.MAX_VALUE,
										},
									]}
									value={element?.commission?.value || 0}
									defaultType={element?.commission?.input || "Percent"}
									error={Boolean(columnsErrors?.[index]?.[key]?.["commission"])}
									disabled={readOnly}
									readOnly={readOnly}
									onChangeType={(_, input) => {
										onChangeType?.(index, key, "row", "commission", input);
									}}
									onActionUpdate={(value) => {
										onActionUpdate?.(index, key, "row", "commission", value);
									}}
									sx={{
										width: "95px",
									}}
								/>
							</Stack>
						);
					})}
				</Stack>
			</Stack>
		</TierRowsItem>
	);
}
MatrixRow.propTypes = {
	index: PropTypes.number,
	item: PropTypes.object,
	fromDisabled: PropTypes.bool,
	toDisabled: PropTypes.bool,
	spaces: PropTypes.object,
	rowsErrors: PropTypes.array,
	columnsErrors: PropTypes.array,
	readOnly: PropTypes.bool,
	spacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	mainContentProps: PropTypes.object,
	sxMainContent: PropTypes.object,
	cellsProps: PropTypes.object,
	sxCells: PropTypes.object,
	onActionUpdate: PropTypes.func,
	onChangeType: PropTypes.func,
};
